import { status } from '../../helpers'

const getCardTemplateStoreDefaultState = () => {
  return {
    loadCardTemplates: status.INITIALIZED,
    loadCards: status.INITIALIZED,
    cardTemplatesList: [],
    cardList: [],
    totalRecords: 0,
    isTemplateSaving: false
  }
}

export default getCardTemplateStoreDefaultState
